import Button from "@components/Button/Button";
import { TrendingKeywordsProps } from "@routes/Search/utils/types";
import { cn } from "@util/helpers";

export default function SearchTrendingKeywords({
  keywords,
  setSelectedKeyword,
}: TrendingKeywordsProps): React.ReactElement {
  return (
    <div
      data-testid="search-trending-keywords-component"
      className="mt-6 md:mt-18"
    >
      <div className="mb-6 flex border-b border-gray-175 py-2">
        <p className="font-poppins text-4xs font-semibold uppercase tracking-5 md:text-xs">
          Trending searches
        </p>
      </div>

      <div className={cn("flex w-full flex-wrap")}>
        {keywords.map((keyword) => {
          return (
            <Button
              key={keyword}
              onClick={() => {
                setSelectedKeyword(keyword || "");
              }}
              className={cn(
                "mb-4 mr-4 w-max rounded-[4px] px-4 py-2 font-medium transition-all duration-300 md:text-lg"
              )}
            >
              {keyword}
            </Button>
          );
        })}
      </div>
    </div>
  );
}
